import type { BusinessUnit, BusinessUnitCostMetrics } from 'services/types/businessUnit';

import baseWorkloadApi from './baseWorkloadApi';

// The Business Unit charts page runs entirely on the workload service (500s timeout) instead of
// the main API (120s): its cost-charts aggregation is heavy, and the page's other reads (BU
// detail + lead sources) ride along so the whole view hits one backend. Other pages keep using
// the main-API variants of these same endpoints (adminBusinessUnits.api / businessUnits.api).
const businessUnitChartsApi = baseWorkloadApi.injectEndpoints({
  endpoints: (build) => ({
    getAdminBusinessUnitCostCharts: build.query({
      query: (props: { id: number; startDate?: string; endDate?: string; sources?: string[] }) => ({
        url: `/admin/businessUnits/${props.id}/cost-charts`,
        method: 'GET',
        params: {
          ...(props.startDate ? { startDate: props.startDate } : {}),
          ...(props.endDate ? { endDate: props.endDate } : {}),
          ...(props.sources && props.sources.length > 0 ? { source: props.sources.join(',') } : {}),
        },
      }),
      transformResponse: (response: BusinessUnitCostMetrics) => response,
    }),
    getAdminBusinessUnit: build.query({
      query: (id: number) => ({
        url: `/admin/businessUnits/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: BusinessUnit) => response,
    }),
    getBusinessUnitSources: build.query({
      query: (props: { businessUnitId: number | null }) => ({
        url: `/businessUnits/businessUnit/sources/${props.businessUnitId || ''}`,
        method: 'GET',
      }),
      transformResponse: (response: string[]): string[] => response,
      keepUnusedDataFor: 3600,
    }),
  }),
  overrideExisting: false,
});

export const { useGetAdminBusinessUnitCostChartsQuery, useGetAdminBusinessUnitQuery, useGetBusinessUnitSourcesQuery } =
  businessUnitChartsApi;
